import { render, staticRenderFns } from "./iconElect.vue?vue&type=template&id=66bbbd8a"
import script from "./iconElect.vue?vue&type=script&lang=js"
export * from "./iconElect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports